import { Project } from '../types';

interface ProjectsProps {
	projects: Project[];
}

function Projects({ projects }: ProjectsProps) {
	return (
		<div id="fh5co-work" className="animate-box">
			<div className="container">
				<div className="row">
					<div className="col-md-8 col-md-offset-2 text-center fh5co-heading">
						<span>Portfolio</span>
						<h2>AI Projects</h2>
						<p>Personal projects exploring AI integration, built with modern web technologies and the Anthropic API.</p>
					</div>
				</div>
				<div className="row">
					{projects.map((project) => (
						<div key={project.title} className="col-md-6">
							<div className="fh5co-blog">
								<div className="blog-text">
									<div className="project-icon-wrap">
										<span className="project-icon">
											<i className={project.icon}></i>
										</span>
									</div>
									<h3>{project.title}</h3>
									<p>{project.description}</p>
									<div className="project-tags">
										{project.tags.map((tag) => (
											<span key={tag} className="project-tag">{tag}</span>
										))}
									</div>
									<ul className="stuff">
										<li>
											<a href={project.url} target="_blank" rel="noopener noreferrer">
												<i className="icon-globe"></i> View App
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}

export default Projects;
